<script>
import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Dialog from 'primevue/dialog';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Toolbar from 'primevue/toolbar';
import GenericCustomMasterDataSelect from '../../components/generic/GenericCustomMasterDataSelect.vue'
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue'
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import { required  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import Service from '../../services/movement-instruction';

export default{
  setup: () => ({ v$: useVuelidate() }),
  components: {
    Dialog, Card, Toolbar, DataTable, Column,
    ResponsiveButton, 
    InputText, Calendar,
    GenericCustomMasterDataAutocompleteV2, GenericCustomMasterDataSelect
  },
  props: ['id', 'readOnly'],
  data(){
    return {
      headers: [],
      headersLoading: false,
      itemsLoading: false,
      selectedHeader: null,
      items: [],

      // BOL HEADER EDIT
      submittedHeader: false,
      saveBoLHeaderDisabled: false,
      bolHeaderDialogVisible: false,
      bolHeaderItem:{
        documentReference: null,
        documentDate: null
      },

      selectedBolHeader: null,

      // BOL ITEMS EDIT
      submittedItem: false,
      saveBoLItemDisabled: false,
      bolItemDialogVisible: false,
      bolItem:{
        grossValue: null,
        idBoLHeader: null,
        netValue: null,
        uoMCode: null
      }
    }
  },
  validations(){
    return {
      bolHeaderItem:{
        documentReference: {required},
        documentDate: {}
      },
      bolItem:{
        grossValue: {},
        idBoLHeader: {},
        netValue: {},
        uoMCode: {required}
      }
    }
  },
  mounted(){
    if(this.id){
      this.loadHeaders();
    }
  },
  computed: {
      constants(){
          return CommonConstants;
      },
      utils(){
        return Utils;
      },
      uiPermissions(){
        return this.$store.getters['security/uiPermissions'];
      }
  },
  methods: {
    reload(){
      this.loadHeaders();
    },
    loadHeaders(){
      let filters = [
        {
          operator: 'eq',
          value: this.id,
          property: 'IdMovementInstructionLot'
        }
      ];
      let params = {
          filter: JSON.stringify(filters),
      }

      this.headersLoading = true;
      Service.getLotBoLHeaders(params, response => {
        this.headersLoading = false;
        if(response.success){
          this.headers = response.data;
        }else{
          this.headers = [];
        }
      });
    },
    onHeaderSelect(e){
      this.selectedBolHeader = e.data.id;
      this.loadItems(e.data.id);
    },
    loadItems(headerId){
      let filters = [
        {
          operator: 'eq',
          value: headerId,
          property: 'IdBoLHeader'
        }
      ];
      let params = {
          filter: JSON.stringify(filters),
      }

      Service.getLotBoLItems(params, response => {
        if(response.success){
          this.items = response.data;
        }else{
          this.items = [];
        }
      })
    },
    onDeleteHeader(data, event){
      this.$confirm.require({
        target: event.currentTarget,
        message: this.$t('messages.delete_message_question'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {
          Service.deleteLotBoLHeader(data.id, 
            response => {
              if(response.success){
                this.loadHeaders();
                this.$confirm.close();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
              }
              else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        },
        reject: () => {
            //callback to execute when user rejects the action
            this.$confirm.close();
        }
      });
    },
    onDeleteItem(data, event){
      this.$confirm.require({
        target: event.currentTarget,
        message: this.$t('messages.delete_message_question'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {
          Service.deleteLotBoItem(data.id, 
            response => {
              if(response.success){
                this.loadItems(data.idBoLHeader);
                this.$confirm.close();
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
              }
              else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        },
        reject: () => {
            //callback to execute when user rejects the action
            this.$confirm.close();
        }
      });
    },

    submitSaveBolHeader(){
      this.submittedHeader = true;
      if(!this.v$.bolHeaderItem.$invalid){
        this.saveBoLHeaderDisabled = true;
        if(this.bolHeaderItem.id){
          Service.updateLotBoLHeader(this.bolHeaderItem, 
            response => {
              this.submittedHeader = false;
              this.saveBoLHeaderDisabled = false;
              if(response.success){
                this.loadHeaders();
                this.bolHeaderDialogVisible = false;
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        }else{
          Service.createLotBoLHeader(this.bolHeaderItem, 
            response => {
              this.submittedHeader = false;
              this.saveBoLHeaderDisabled = false;
              if(response.success){
                this.loadHeaders();
                this.bolHeaderDialogVisible = false;
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        }
      }
    },
    openBolHeaderDialogEdit(data){
      this.bolHeaderItem = {...data};  
      if(this.bolHeaderItem.documentDate){
        this.bolHeaderItem.documentDate = Utils.dateToCurrentTimeZone(this.bolHeaderItem.documentDate);
      }
      this.bolHeaderDialogVisible = true;
    },
    openBolHeaderDialog(){
      this.bolHeaderItem = {
        idMovementInstructionLot: this.id,
        documentReference: null,
        documentDate: null
      }
      this.bolHeaderDialogVisible = true;
    },
    submitSaveBolItem(){
      this.submittedItem = true;
      if(!this.v$.bolItem.$invalid){
        this.saveBoLItemDisabled = true;
        if(this.bolItem.id){
          Service.updateLotBoLItem(this.bolItem, 
            response => {
              this.saveBoLItemDisabled = false;
              this.submittedItem = false;
              if(response.success){
                this.bolItemDialogVisible = false;
                this.loadItems(this.bolItem.idBoLHeader);
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        }else{
          Service.createLotBoLItem(this.bolItem, 
            response => {
              this.saveBoLItemDisabled = false;
              this.submittedItem = false;
              if(response.success){
                this.bolItemDialogVisible = false;
                this.loadItems(this.bolItem.idBoLHeader);
                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
              }else{
                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
              }
            }
          )
        }
      }
    },
    openBolItemDialogEdit(data){
      this.bolItem = {...data};
      this.bolItemDialogVisible = true;
    },
    openBolItemDialog(){
      if(this.selectedBolHeader){
        this.bolItem = {
          grossValue: null,
          netValue: null,
          uoMCode: null,
          idBoLHeader: this.selectedBolHeader
        };
        this.bolItemDialogVisible = true;
      }else{
        this.$toast.add({detail: this.$t('movementInstructions.messages.bolHeaderNotSelected'), life:3000, severity:'error'});
      }
    }
  }
}

</script>

<style scoped>
.custom-card-title{
  font-size: 18px;
}
</style>

<template>
  <main>
    <div class="grid">
        <div class="col-12">
          <div class="card">
            <div class="grid">
              <Card class="col-12" >
                <template #content>
                  <Dialog v-model:visible="bolHeaderDialogVisible" modal class="p-fluid">
                    <div class="field">
                      <label for="bolHeaderDocumentNumber" :class="{'p-error':v$.bolHeaderItem.documentReference.$invalid && submittedHeader}">{{$t('documentNumber')}}</label>
                      <InputText class="w-full p-inputtext-sm mt-1 " id="bolHeaderDocumentNumber" type="text" v-model="bolHeaderItem.documentReference"
                        :class="{'p-invalid':v$.bolHeaderItem.documentReference.$invalid && submittedHeader, 'w-full p-inputtext-sm mt-1 ': true}" />
                        <div v-if="(v$.bolHeaderItem.documentReference.$invalid && submittedHeader) || v$.bolHeaderItem.documentReference.$pending.$response">
                          <small class="p-error" v-for="error in v$.bolHeaderItem.documentReference.$silentErrors" :key="error.$validator">
                              {{error.$message}}
                          </small>
                        </div>
                    </div>
                    <div class="field">
                      <label for="bolHeaderDocumentDate">{{$t('documentDate')}}</label>
                      <Calendar 
                        id="bolHeaderDocumentDate" 
                        :showTime="false" :showSeconds="false"
                        v-model="bolHeaderItem.documentDate"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                        :dateFormat="constants.DATE_FORMAT"
                        :class="{'w-full p-inputtext-sm mt-1 ': true}" />
                    </div>
                    <template #footer>
                      <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="bolHeaderDialogVisible = false"/>
                      <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="submitSaveBolHeader" :disabled="saveBoLHeaderDisabled"/>
                    </template>
                  </Dialog>
                  
                  <div class="grid">
                    <div class="col-12">
                      <DataTable :value="headers" 
                        :reorderableColumns="true"
                        showGridlines stripedRows
                        dataKey="id"
                        v-model:selection="selectedHeader" selectionMode="single" @rowSelect="onHeaderSelect"
                        :loading="headersLoading">
                         <template #header>
                          <Toolbar>
                            <template #start>
                                <div class="custom-card-title">{{$t('header')}}</div>
                            </template>

                            <template #end>
                               <ResponsiveButton :label="$t('btn.add')" :disabled="!uiPermissions('MovementInstruction.Lot.BillOfLading').isEnabled || readOnly" icon="pi pi-plus" class="p-button-outlined p-button-sm" @click="openBolHeaderDialog"  />
                            </template>
                        </Toolbar>
                       </template>
                        <Column  :reorderableColumn="false" :exportable="false" style="width:10%; min-width:8rem" v-if="!readOnly">
                          <template #body="slotProps">
                            <ResponsiveButton icon="pi pi-pencil" :disabled="!uiPermissions('MovementInstruction.Lot.BillOfLading').isEnabled || readOnly" class="grid-action-btn p-button-rounded p-button-outlined" @click="openBolHeaderDialogEdit(slotProps.data)" />
                            <ResponsiveButton icon="pi pi-trash" :disabled="!uiPermissions('MovementInstruction.Lot.BillOfLading').isEnabled || readOnly" class="grid-action-btn p-button-rounded p-button-outlined" @click="onDeleteHeader(slotProps.data, $event)" />
                          </template>
                        </Column>
                        <Column field="documentReference" :header="$t('documentNumber')" dataType="string" :sortable="true">
                          <template #editor="{ data, field }">
                            <InputText v-model="data[field]" autofocus />
                          </template>
                          <template #body="element">
                            {{element.data.documentReference}}
                          </template>
                        </Column>
                        <Column field="documentDate" :header="$t('documentDate')" dataType="date" :sortable="true">
                          <template #editor="{ data, field }">
                            <InputText v-model="data[field]" autofocus />
                          </template>
                          <template #body="element">
                            {{element.data.documentDate ? utils.formatDate(utils.dateToCurrentTimeZone(element.data.documentDate)): null}}
                          </template>
                        </Column>

                        <template #empty>
                          {{$t('noRecordsFound')}}
                        </template>
                      </DataTable>
                    </div>
                  </div>
                </template>
              </Card>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="card">
            <div class="grid">
              <Card class="col-12" >
                <template #content>
                  <Dialog v-model:visible="bolItemDialogVisible" modal class="p-fluid">
                    <div class="field">
                      <label for="addGrossQty">{{$t('grossQuantity')}}</label>
                      <InputText type="number" class="w-full p-inputtext-sm mt-1 " id="addGrossQty" v-model="bolItem.grossValue"  />
                    </div>
                    <div class="field">
                      <label for="addNetQty">{{$t('netQuantity')}}</label>
                      <InputText type="number" class="w-full p-inputtext-sm mt-1 " id="addNetQty" v-model="bolItem.netValue"  />
                    </div>
                    <div class="field">
                      <label for="addUoM" :class="{'p-error':v$.bolItem.uoMCode.$invalid && submittedItem}">{{$t('unitofMeasureCode')}}</label>
                      <generic-custom-master-data-autocomplete-v-2
                       class="w-full p-inputtext-sm mt-1 "
                        id="addUoM"
                        name="units-of-measure"
                        v-model="bolItem.uoMCode" 
                        api="masterdata/unit-of-measure-combo?getOnlyValid=true&scope=MovementInstruction"
                        :format="{label: 'code', value: 'code' }" sortField="Code" 
                        :class="{'p-invalid':v$.bolItem.uoMCode.$invalid && submittedItem, 'w-full p-inputtext-sm mt-1 ': true}" />
                        <div v-if="(v$.bolItem.uoMCode.$invalid && submittedItem) || v$.bolItem.uoMCode.$pending.$response">
                          <small class="p-error" v-for="error in v$.bolItem.uoMCode.$silentErrors" :key="error.$validator">
                              {{error.$message}}
                          </small>
                        </div>
                    </div>
                    <template #footer>
                      <ResponsiveButton :label="$t('btn.cancel')" icon="pi pi-times" class="p-button-text" @click="bolItemDialogVisible = false"/>
                      <ResponsiveButton :label="$t('btn.save')" icon="pi pi-check" class="p-button-text" @click="submitSaveBolItem" :disabled="saveBoLItemDisabled"/>
                    </template>
                  </Dialog>
                  <div class="grid">
                    <div class="col-12">
                      <DataTable :value="items" :reorderableColumns="true" showGridlines stripedRows :loading="itemsLoading"
                      :totalRecords="items.length">
                        <template #header>
                          <Toolbar>
                            <template #start>
                                <div class="custom-card-title">{{$t('details')}}</div>
                            </template>

                            <template #end>
                              <ResponsiveButton :label="$t('btn.add')" :disabled="!uiPermissions('MovementInstruction.Lot.BillOfLading').isEnabled || readOnly" icon="pi pi-plus" class="p-button-outlined p-button-sm" @click="openBolItemDialog"  />
                            </template>
                        </Toolbar>
                       </template>
                        <Column :exportable="false" style="min-width:8rem"  :reorderableColumn="false">
                          <template #body="slotProps">
                            <ResponsiveButton icon="pi pi-pencil" :disabled="!uiPermissions('MovementInstruction.Lot.BillOfLading').isEnabled || readOnly" class="grid-action-btn p-button-rounded p-button-outlined" @click="openBolItemDialogEdit(slotProps.data)" />
                            <ResponsiveButton :disabled="!uiPermissions('MovementInstruction.Lot.BillOfLading').isEnabled || readOnly" icon="pi pi-trash" class="grid-action-btn p-button-rounded p-button-outlined" @click="onDeleteItem(slotProps.data, $event)" />
                          </template>
                        </Column>
                        <Column 
                          field="grossValue" :header="$t('grossQuantity')" dataType="number" 
                          :sortable="true">
                          <template #body="element">
                            {{element.data.grossValue}}
                          </template>
                          <template #editor="{ data, field }">
                            <InputText type="number" v-model="data[field]" autofocus />
                          </template>
                        </Column>
                        <Column 
                          field="netValue" :header="$t('netQuantity')" dataType="number" 
                          :sortable="true">
                          <template #body="element">
                            {{element.data.netValue}}
                          </template>
                          <template #editor="{ data, field }">
                            <InputText type="number" v-model="data[field]" />
                          </template>
                        </Column>
                        <Column 
                          field="uoMCode" :header="$t('unitofMeasureCode')" dataType="string" 
                          :sortable="true">
                          <template #body="element">
                            {{element.data.uoMCode}}
                          </template>
                          <template #editor="{ data, field }">
                            <GenericCustomMasterDataSelect :disabled="readOnly" class="w-full p-inputtext-sm mt-1 "
                              name="units-of-measure"
                              v-model="data[field]" 
                              api="masterdata/unit-of-measure-combo?getOnlyValid=true&scope=MovementInstruction"
                              :format="{label: 'code', value: 'code' }" sortField="Code" />
                          </template>
                        </Column>
                        
                        <template #empty>
                          {{$t('noRecordsFound')}}
                        </template>
                      </DataTable>
                    </div>
                  </div>
                </template>
              </Card>
            </div>
          </div>
        </div>
    </div>
  </main>
</template>
